














import * as _ from 'lodash';
import {Vue, Component} from 'vue-property-decorator';
import {Getter, namespace} from 'vuex-class';
import imageToolbar from './image-toolbar/image-toolbar.vue';
import imageEditor from './image-editor/image-editor.vue';
import imageNavigator from './image-navigator/image-navigator.vue';

const ImageFilterGetter = namespace('imageFilter', Getter);

@Component({
  components: {
    imageToolbar,
    imageEditor,
    imageNavigator,
  },
})
export default class ImageFilter extends Vue {
  @ImageFilterGetter('isNavigatorOpen') private isNavigatorOpen: boolean;

  private navigatorWidth: string = '300px';
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/image-filter/image-filter.vue